@if (count() !== null) {
  <span
    class="ml-2 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-teal-700 text-white text-xs font-medium">
    {{ count() }}
  </span>
}
